'use client';

import callWebVitalsLogs from '@actr/widgets/src/logs/web-vitals';
import React from 'react';

callWebVitalsLogs();

// eslint-disable-next-line react/jsx-no-useless-fragment
const WebVitalsHoc: React.FC<{children: React.ReactNode}> = ({ children }) => <>{children}</>;

export default WebVitalsHoc;
